import React from 'react';
import './PolicyDespotismDescription.css';
import {CoinsStat} from "../../../PlayerStat/stats/CoinsStat";
import {getUnitPrice, UNIT_TYPES} from "../../../../configs/units";
import {POLICY_DESPOTISM_BUILDING_DISCOUNT_MILITARY_CAMP} from "../../../../configs/policy/despotism";

const PolicyDespotismDescription = ({policy}) => {
  const discountElementBeforeColon = <img
    className={'policy-description-icon policy-description-icon-margin-left-end'}
    src={'/img/icons/percent white.png'}
    alt={'Скидка'}
    title={'Скидка'}
  />;

  const discountElement = <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/percent white.png'}
    alt={'Скидка'}
    title={'Скидка'}
  />

  const {price: d6Price} = getUnitPrice(UNIT_TYPES.D6.id, {policy})
  const {price: d10Price} = getUnitPrice(UNIT_TYPES.D10.id, {policy})
  const {price: d20Price} = getUnitPrice(UNIT_TYPES.D20.id, {policy})
  const {price: d8Price} = getUnitPrice(UNIT_TYPES.D8.id, {policy})
  const {price: d12Price} = getUnitPrice(UNIT_TYPES.D12.id, {policy})

  const militaryCamp = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right'}
    src={'/img/hexes/special buildings/military camp.1216e2cd.png'}
    alt={'Лагерь'}
    title={'Лагерь'}
  />

  const militaryCampDiscount =
    <CoinsStat
      text={POLICY_DESPOTISM_BUILDING_DISCOUNT_MILITARY_CAMP}
      noShrinkOnMobile={true}
      isDarkColor={true}
      className={'policy-description-icon-margin-left-end'}
    />

  return (
    <>
      <div className={'policy-description_line'}>
        Найм отрядов дешевле {discountElementBeforeColon} :
      </div>
      <div className={'policy-description_line'}>
        <img
          className={'policy-description-icon-unit policy-description-icon-unit-margin-right'}
          src={'/img/icons/unit d6 friend.png'}
          alt={'Отряд Пехота (макс. размер 6)'}
          title={'Отряд Пехота (макс. размер 6)'}
        />
        <CoinsStat
          text={d6Price}
          noShrinkOnMobile={true}
          isDarkColor={true}
        />
        ,
        <img
          className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
          src={'/img/icons/unit d10 friend.png'}
          alt={'Отряд Тяжелая Пехота (макс. размер 10)'}
          title={'Отряд Тяжелая Пехота (макс. размер 10)'}
        />
        <CoinsStat
          text={d10Price}
          noShrinkOnMobile={true}
          isDarkColor={true}
        />
        ,
        <img
          className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
          src={'/img/icons/unit d20 friend.png'}
          alt={'Отряд Элитная Пехота (макс. размер 20)'}
          title={'Отряд Элитная Пехота (макс. размер 20)'}
        />
        <CoinsStat
          text={d20Price}
          noShrinkOnMobile={true}
          isDarkColor={true}
        />
        ,
      </div>
      <div className={'policy-description_line'}>
        <img
          className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
          src={'/img/icons/unit d8 friend.png'}
          alt={'Отряд Легкая Кавалерия (макс. размер 8)'}
          title={'Отряд Легкая Кавалерия (макс. размер 8)'}
        />
        <CoinsStat
          text={d8Price}
          noShrinkOnMobile={true}
          isDarkColor={true}
        />
        ,
        <img
          className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
          src={'/img/icons/unit d12 friend.png'}
          alt={'Отряд Тяжёлая Кавалерия (макс. размер 12)'}
          title={'Отряд Тяжёлая Кавалерия (макс. размер 12)'}
        />
        <CoinsStat
          text={d12Price}
          noShrinkOnMobile={true}
          isDarkColor={true}
        />
        .
      </div>

      <div className={'policy-description_line policy-description_line-margin-top'}>
        {militaryCamp} дешевле {discountElement} на {militaryCampDiscount}.
      </div>
    </>
  );
};

export default PolicyDespotismDescription;
